class HomeTopBack {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    if (window.matchMedia('(max-width: 768px)').matches) {
      // ウィンドウサイズ768px以下のときの処理
      const btn = document.querySelector(".js-top-back");

      btn.addEventListener("click", () => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      });
    }

  }
}
